import script from "./ProductSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductSku.vue?vue&type=script&lang=ts&setup=true"

import "./ProductSku.vue?vue&type=style&index=0&id=61e476f3&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e476f3"]])

export default __exports__